import React from 'react';

import styles from './loader.styles';

interface Props {
    isAbsolute?: boolean;
    loaderClass?: string;
}

const Loader: React.FC<Props> = ({ isAbsolute = true, loaderClass = '' }) => (
    <div className={`${isAbsolute ? 'absolute' : ''} flex justify-center items-center w-full h-full z-10`}>
        <style jsx>{styles}</style>
        <div className={'Loading ' + loaderClass}></div>
    </div>
);

export default Loader;
